import React from 'react';
import { connect } from 'react-redux';
import { ExploringActivitiesCarouselProps, mapStateToProps } from 'component/page/detail/ExploringActivitiesCarousel/ExploringActivitiesCarousel.selectors';
import { Box } from '@drone-js/core';
import { OperationKey } from 'store/api/api.types';
import RecommendedActivitiesCarousel from 'component/common/RecommendedActivitiesCarousel/RecommendedActivitiesCarousel';
import { ValueFilterType } from 'gql/autogen/ValueFilterType';
import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';

export const ExploringActivitiesCarouselComponent: React.FC<ExploringActivitiesCarouselProps> = (props) => {
    const { cms, categoryId, cityId, cityName, activityId } = props;
    const searchResultNumber = 12;

    return (
        <Box backgroundColor="base.surface" pb="24" data-testid="detail-page-exploring-carousel-container">
            <RecommendedActivitiesCarousel
                operationKey={OperationKey.DetailPageExploringActivitiesCarousel}
                title={cms[343921]}
                cityId={cityId}
                cityName={cityName}
                numberOfActivities={searchResultNumber}
                dataElementName="detail-page-exploring-carousel"
                filterActivityId={activityId?.toString()}
                filterType={ValueFilterType.Exclude}
                filterCategory={categoryId}
                defaultSort={{ code: SortCode.ActivitiesDetailsPageExploreActivitiesCarousel, order: SortOrder.Descending }}
            />
        </Box>
    );
};
ExploringActivitiesCarouselComponent.displayName = 'ExploringActivitiesCarousel';

const ExploringActivitiesCarousel = connect(mapStateToProps)(ExploringActivitiesCarouselComponent);
export default ExploringActivitiesCarousel;
